module.exports = __webpack_public_path__ + "static/media/team arm care.b671c13b.png";